import { Card, CardContent } from "./ui/card";
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Parent",
    rating: 5,
    comment: "My daughter Emma absolutely loves coming here! The teachers are amazing and the programs are perfectly designed for young learners. I've seen such growth in her confidence and curiosity.",
    avatar: "SJ"
  },
  {
    name: "Mike Chen",
    role: "Parent",
    rating: 5,
    comment: "The creative arts program has unlocked my son's artistic talents. He comes home excited to share what he learned and created. The environment is nurturing and inspiring.",
    avatar: "MC"
  },
  {
    name: "Lisa Rodriguez",
    role: "Parent",
    rating: 5,
    comment: "Outstanding quality of education and care. The reading program has helped my twins develop a genuine love for books. The staff goes above and beyond for every child.",
    avatar: "LR"
  }
];

export function Testimonials() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium">
            Testimonials
          </span>
          <h2 className="text-4xl font-bold text-gray-800 mt-4 mb-6">
            What Parents Say About Us
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what families in our community 
            have to say about their experience with us.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="border-0 shadow-lg hover:shadow-xl transition-shadow duration-300 relative">
              <CardContent className="p-8">
                <Quote className="w-10 h-10 text-orange-300 mb-4" />
                
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                
                <p className="text-gray-600 mb-6 leading-relaxed italic">
                  "{testimonial.comment}"
                </p>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center mr-4">
                    <span className="text-white font-bold">{testimonial.avatar}</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-800">{testimonial.name}</h4>
                    <p className="text-sm text-gray-500">{testimonial.role}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}